import cn from 'classnames';

import { useWindowWidth } from '@/hooks/useWindowWidth';

import s from './MainSlide.module.scss';

interface MainSlideProps {
  title: string;
  description: string;
  photo: string;
  number: number;
}

const MainSlide = ({ title, description, photo, number }: MainSlideProps) => {
  const {
    windowWidth,
    breakpoints: { SM },
  } = useWindowWidth();

  return (
    <div className={cn(s.root)}>
      {windowWidth && windowWidth > SM && (
        <div className={s.top}>
          <div className={s.titleWrapper}>
            <h3
              className={s.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
          <div className={s.number}>0{number}</div>
        </div>
      )}
      {windowWidth && windowWidth <= SM && (
        <div className={s.titleWrapper}>
          <h3 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
        </div>
      )}
      <div className={s.bottom}>
        <div
          className={s.text}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
      <div className={s.photoWrapper}>
        {windowWidth && windowWidth <= SM && (
          <div className={s.number}>0{number}</div>
        )}
        <div className={s.shape} />
        <img
          src={photo}
          className={s.person}
          alt="person"
          width={484}
          height={560}
        />
      </div>
    </div>
  );
};

export { MainSlide };
